import { type BlockGridParameters, useBlockGrid } from '@/hooks/useBlockGrid';
import { Block } from './Block';

export const BlockSet: React.FC<BlockGridParameters> = ({
  width,
  height,
  seed,
  circleProbability,
  quarterCircleProbability,
  rectangleProbability,
  colorVariety,
  sameColorAdjacencyWeight,
}) => {
  const blockGrid = useBlockGrid({
    width,
    height,
    seed,
    circleProbability,
    quarterCircleProbability,
    rectangleProbability,
    colorVariety,
    sameColorAdjacencyWeight,
  });

  return (
    <div
      className="grid grid-flow-row"
      style={{ gridTemplateColumns: `repeat(${width}, 45px)` }}
    >
      {blockGrid.flat().map((blockConfig, index) => (
        <div key={index} className="w-[45px] h-[45px]">
          <Block block={blockConfig} compact />
        </div>
      ))}
    </div>
  );
};
